import { render, staticRenderFns } from "./Articolo.vue?vue&type=template&id=584ecd0c&"
import script from "./Articolo.vue?vue&type=script&lang=js&"
export * from "./Articolo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports